/**
 * @description Component-MobileHistory
 */
import './index.less';

import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import SynTitleTabs from '@/components/Tabs/SynTitleTabs';
import { HISTORY_TYPE } from '@/constants/history';
import AccountHistory from './AccountHistory';
import FundingHistory from './FundingHistory';
import LiquidityHistory from './LiquidityHistory';
import OrderHistory from './OrderHistory';
import TradeHistory from './TradeHistory';
import TransferHistory from './TransferHistory';

interface IPropTypes {
  className?: string;
  defaultType?: HISTORY_TYPE;
  isTradePage?: boolean;
  historyType?: HISTORY_TYPE;
  setHistoryType?: (type: HISTORY_TYPE) => void;
}

const MobileHistory: FC<IPropTypes> = ({ className, isTradePage = false, historyType, setHistoryType }) => {
  const { t } = useTranslation();

  const items = [
    { label: t('common.historyC.trade'), key: HISTORY_TYPE.TRADE },
    { label: t('common.historyC.orders'), key: HISTORY_TYPE.ORDERS },
    { label: t('common.liquidity'), key: HISTORY_TYPE.LIQUIDITY },
    { label: t('common.historyC.funding'), key: HISTORY_TYPE.FUNDING },
    { label: t('common.historyC.transfers'), key: HISTORY_TYPE.TRANSFERS },
    { label: t('common.historyC.account'), key: HISTORY_TYPE.ACCOUNT },
  ].filter((item) => !(isTradePage && item.key === HISTORY_TYPE.ACCOUNT));

  return (
    <div className={classNames('syn-mobile-history', className)}>
      <div className="syn-mobile-history-header">
        <SynTitleTabs
          activeKey={historyType}
          items={items}
          onClick={(key) => {
            setHistoryType?.(key as HISTORY_TYPE);
          }}
          className="syn-mobile-history-tabs"
        />
      </div>
      <div className="syn-mobile-history-content">
        {historyType === HISTORY_TYPE.TRADE && <TradeHistory isTradePage={isTradePage} />}
        {historyType === HISTORY_TYPE.ORDERS && <OrderHistory isTradePage={isTradePage} />}
        {historyType === HISTORY_TYPE.LIQUIDITY && <LiquidityHistory isTradePage={isTradePage} />}
        {historyType === HISTORY_TYPE.FUNDING && <FundingHistory isTradePage={isTradePage} />}
        {historyType === HISTORY_TYPE.TRANSFERS && <TransferHistory isTradePage={isTradePage} />}
        {historyType === HISTORY_TYPE.ACCOUNT && <AccountHistory isTradePage={isTradePage} />}
      </div>
    </div>
  );
};

export default MobileHistory;
